/**
 * App.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

import React from "react";
import { Result } from "antd";
import "./App.css";
//redux
import { connect } from "react-redux";
//components
import AppLayout from "./layout/AppLayout";
import Main from "./components/influencer/Main";

//TODO: SHOW KEYBOARD SHORTCUTS AND BAD PROFILE INSTRUCTIONS AS MODAL
//TODO: CHECK IF THUMBNAILS CONTAIN HTTPS IF NOT SHOW SHORTCODES
//TODO: IF THUMBNAILS EXPIRES AND RETURNS 403 - GET IMAGE FROM SHORTCODE
const App = props => (
  <AppLayout>
    {props.result ? (
      <Result
        title={props.result.title}
        status={props.result.status}
        subTitle={props.result.subtitle || null}
      />
    ) : props.redirecting ? (
      <h3 style={{ ...styles.centered, top: "60%" }}>
        Redirecting to sign in...
      </h3>
    ) : (
      <Main />
    )}
  </AppLayout>
);

const styles = {
  centered: {
    //centered in the middle of screen
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center"
  }
};

const mapStateToProps = state => {
  return {
    result: (state.data && state.data.result) || null,
    redirecting: (state.auth && state.auth.redirecting) || false //access 'data' attribute of Redux state as this.props.data
  };
};

export default connect(mapStateToProps)(App);
